<script setup>
//アカウント情報をサーバと通信して取得するモジュール
import AccountRepository from "@/components/AccountRepository.js";
//const AccountRepository = () => import('../components/AccountRepository.js');
//ルート情報を保持するモジュール
import { useRouter } from "vue-router";
import { ref, onMounted, onUnmounted } from "vue";

import { getErrorMessage } from "@/components/Error";
import "bootstrap-icons/font/bootstrap-icons.css";

//画面のuserid、passwordとバインドさせる変数
const loginForm = ref({ id: "", password: "" });

const showPassword = ref(false); // falseのときはpasswordタイプ、trueのときはtextタイプ
const isDarkMode = ref(
  window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
);

//ログイン結果のメッセージ表示用
const message = ref(null);

//AccountRepositoryモジュールからの変数、メソッドを宣言
const { loginAccount } = AccountRepository();
const router = useRouter();

onMounted(() => {
  document.body.style.overflow = "hidden";
});

onUnmounted(() => {
  document.body.style.overflow = "";
});
// ダークモードの設定が変わった時にVueの変数を更新するためのリスナーを設定
onMounted(() => {
  const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const changeHandler = (e) => {
    isDarkMode.value = e.matches;
  };
  darkModeMediaQuery.addListener(changeHandler);

  // コンポーネントが破棄された時にリスナーを削除
  onUnmounted(() => {
    darkModeMediaQuery.removeListener(changeHandler);
  });
});

const login = async () => {
  message.value = null;

  if (!loginForm.value.id || !loginForm.value.password) {
    message.value = "ユーザID又はパスワードが入力されていません。";
    return;
  }
  // loginAccountメソッドを呼ぶ、loginAccountは非同期メソッドなので、
  // その結果は await を使用して取得する
  const result = await loginAccount(loginForm.value);
  console.log(result);
  if (result.isLogin) {
    router.push("/");
  } else {
    console.log(result);
    if (result.message && result.message === "Network Error") {
      message.value =
        "ネットワークに問題が発生しました。接続を確認してください。";
    } else if (result.response.status) {
      message.value = getErrorMessage(result.response.status);
    } else {
      message.value = "問題が発生しました。";
    }
  }
};
</script>

<template>
  <div class="main">
    <div class="login-container">
      <div class="login-box form-input">
        <h2 class="logintitle">ログイン</h2>
        <form class="login_page" @submit.prevent>
          <div class="login_form d-flex flex-column">
            <div class="input_label">
              <input
                placeholder="ログインID"
                maxlength="128"
                type="text"
                autocomplete="username"
                v-model="loginForm.id"
              />
            </div>

            <div class="input_label">
              <input
                placeholder="パスワード"
                maxlength="128"
                type="password"
                autocomplete="current-password"
                v-model="loginForm.password"
                v-if="!showPassword"
              />
              <input
                placeholder="パスワード"
                maxlength="128"
                type="text"
                autocomplete="current-password"
                v-model="loginForm.password"
                v-if="showPassword"
              />
              <div>
                <i
                  class="bi pass-visible-eye"
                  :class="
                    showPassword
                      ? isDarkMode
                        ? 'bi bi-eye-fill'
                        : 'bi bi-eye'
                      : isDarkMode
                      ? 'bi bi-eye-slash-fill'
                      : 'bi bi-eye-slash'
                  "
                  @click="showPassword = !showPassword"
                ></i>
              </div>
            </div>
            <div class="error_message">
              <div style="color: red">{{ message }}</div>
            </div>
          </div>
          <div class="login_submit">
            <button class="login_button" @click="login">ログイン</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_form {
  margin: 0 0 1rem 0.7rem;
}

.main {
  display: flex;
  font-weight: bold;
  height: 100%;
}

.logintitle {
  padding: 1em 0;
  text-align: center;
  white-space: nowrap;
  font-weight: bold;
}

.login_submit {
  margin: 0.5rem 0;
}

.login_submit button {
  height: 50px;
  width: 95%;
  font-size: 1.2em;
  font-weight: bold;
  border: solid 1px #3b7cb4;
  box-shadow: 0 0.1rem 0.1rem 0 rgba(96, 96, 96, 0.5);
  border-radius: 0.3rem;
  background: #62acb4;
  background: linear-gradient(180deg, #62acb4, #346cb4);
}

.login_submit button:hover {
  opacity: 0.8;
}

.input_label {
  margin: 0.8rem 0;
  position: relative;
}

.input_label input {
  font-family: sans-serif;
  font-size: 1em;
  height: 50px;
  transition: border-color 0.3s;
  width: 95% !important;
  box-sizing: border-box;
}

.login_button {
  background-color: forestgreen;
  color: white;
  margin: 1rem 0 1.5rem 0.3rem;
}

/*
input:-webkit-autofill {
  transition: background-color 10000s ease-in-out 0s;
}*/

.pass-visible-eye {
  position: absolute;
  top: 3.3rem;
  left: 20.7rem;
  /* この値を調整して、アイコンの位置を変更することができます。 */
  transform: translateY(-160%);
  cursor: pointer;
}

/* Edgeブラウザのみのスタイル */
@supports (-ms-ime-align: auto) {
  .pass-visible-eye {
    display: none !important; /* !importantは必要に応じて */
  }
}
</style>
